import { log } from "../../../";

import * as React from "react";
import { observer } from "mobx-react";
import { action } from "mobx";

import * as CustomLists from "../../../models/customLists";
import { BrowseListsStore } from "../../../stores/BrowseListsStore";
import { CategoryCard } from "./CategoryCard";
import DraggableFolderItem from "../DraggableFolderItem";
import DragDropFolder from "../DragDropFolder";
import { CategoryMenuFolderCard } from "../CategoryMenuFolderCard";
import { Button, Grid, IconButton, Paper, Typography } from "@material-ui/core";
import { strings } from "core/localizedStrings";
import { Colors } from "core/utils/Colors";
import * as Icons from "core/utils/Icons";

var ReactList = require("react-list");

export interface FetchListProps extends React.Props<any> {
    store: BrowseListsStore;
}

@observer
class FetchList extends React.Component<FetchListProps> {
    render() {
        let totalCount = this.props.store.visibleItems.length + 1;
        return (
            <ReactList
                key={
                    this.props.store.visibleFolder
                        ? this.props.store.visibleFolder.key + this.props.store.languageFilter
                        : ""
                }
                type="simple"
                itemRenderer={this.renderItem}
                length={totalCount}
                pageSize={20}
            />
        );
    }

    private itemDroppedOnFolder = (source: any, target: any) => {
        let targetFolder = target.props.folder;
        if (source.type === CategoryMenuFolderCard) {
            let sourceFolder = source.props.folder;
            this.props.store.moveFolderToFolder(sourceFolder, targetFolder, this.props.store.currentTab);
        } else if (source.type === CategoryCard) {
            let sourceCategory = source.props.category;
            this.props.store.moveItemToFolder(sourceCategory, targetFolder, this.props.store.currentTab);
        }
    };

    @action
    private renderItem = (index: number, key: string) => {
        if (this.props.store.visibleItems.length > 1 && this.props.store.visibleItems.length === index) {
            return null;
        }
        if (this.props.store.visibleItems === undefined || this.props.store.visibleItems.length === 0) {
            if (this.props.store.currentTab === CustomLists.TabSelection.MY_LISTS && !this.props.store.isSearching) {
                if (this.props.store.rootStore.authStore.isSignedIn) {
                    return (
                        <Paper style={{ marginTop: 30, padding: 20, width: "100%" }} square={true}>
                            <Grid container justify="center" alignItems="center" direction="column">
                                <Grid item>
                                    <Typography variant="h6">{strings.noListsGetStarted}</Typography>
                                </Grid>
                                <Grid item>
                                    <IconButton
                                        onClick={() => {
                                            this.props.store.setShouldShowCategoryListSelector(true);
                                        }}
                                    >
                                        <Icons.AddList style={{ width: 50, height: 50 }} />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Paper>
                    );
                } else {
                    return (
                        <Paper style={{ marginTop: 30, padding: 20, width: "100%" }} square={true}>
                            <Grid container justify="center" alignItems="center" direction="column">
                                <Grid item>
                                    <Typography variant="h6">{strings.loginToCreateLists}</Typography>
                                </Grid>
                                <Grid item>
                                    <Button
                                        onClick={() => {
                                            this.props.store.rootStore.authStore.setShouldShowSignInDialog(true);
                                        }}
                                    >
                                        <span style={{ color: Colors.lightBlue }}>{strings.signInRegister}</span>
                                    </Button>
                                </Grid>
                            </Grid>
                        </Paper>
                    );
                }
            }
            return null;
        }

        let totalItems = this.props.store.visibleItems.length;
        let singleItemLoaded = totalItems === 1 && index === 1;

        if (totalItems > index || singleItemLoaded) {
            let item = this.props.store.visibleItems[index];
            if (item instanceof CustomLists.Folder) {
                return (
                    <DragDropFolder
                        key={item.key}
                        onDroppedOnTarget={this.itemDroppedOnFolder}
                        childObject={
                            <CategoryMenuFolderCard
                                onBackgroundClickedCallback={this.props.store.folderSelected.bind(this.props.store)}
                                folder={item as CustomLists.Folder}
                                store={this.props.store}
                            />
                        }
                    />
                );
            } else if (item instanceof CustomLists.Category) {
                let category = item as CustomLists.Category;
                return (
                    <DraggableFolderItem
                        key={item.key}
                        onItemDropped={this.itemDroppedOnFolder}
                        childObject={<CategoryCard category={category} store={this.props.store} />}
                    />
                );
            } else {
                log.verbose("Unknown list item type");
                return null;
            }
        }

        return null;
    };
}

export default FetchList;
